import React from 'react';

import { useIntl } from 'react-intl';

import { BarToolTip } from '../BarToolTip';

export function Help() {
  const { messages } = useIntl();

  return (
    <BarToolTip title={messages.head.faq}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2743_3984)">
          <path
            d="M7.57502 7.50002C7.77094 6.94308 8.15765 6.47344 8.66665 6.1743C9.17565 5.87515 9.7741 5.7658 10.356 5.86561C10.9379 5.96543 11.4657 6.26796 11.8459 6.71963C12.2261 7.1713 12.4342 7.74296 12.4334 8.33335C12.4334 10 9.93335 10.8334 9.93335 10.8334M10 14.1667H10.0084M18.3334 10C18.3334 14.6024 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6024 1.66669 10C1.66669 5.39765 5.39765 1.66669 10 1.66669C14.6024 1.66669 18.3334 5.39765 18.3334 10Z"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </BarToolTip>
  );
}
